import React, { Component } from 'react';
import moment from 'moment/moment';
import { Timeline } from 'primereact/timeline';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { UtilService } from 'hay-core-react';
const TIPOLOG_CONEXAO = 'main.usuariologacesso.tipolog.conexao';

const ICONE_POR_DISPOSITIVO = {
    'main.usuariologacesso.dispositivo.smartphone': 'pi-mobile',
    'main.usuariologacesso.dispositivo.tablet': 'pi-tablet',
    'main.usuariologacesso.dispositivo.tv': 'pi-desktop',
    'main.usuariologacesso.dispositivo.desktop': 'pi-desktop',
    'main.usuariologacesso.dispositivo.smartwatch': 'pi-clock',
};

function agruparPorDia(itens) {
    const hoje = moment().startOf('day');
    const ontem = moment().subtract(1, 'day').startOf('day');
    const grupos = { hoje: [], ontem: [], anteriores: [] };

    itens.forEach((item) => {
        const dia = moment(item.datalog).startOf('day');
        if (dia.isSame(hoje)) {
            grupos.hoje.push(item);
        } else if (dia.isSame(ontem)) {
            grupos.ontem.push(item);
        } else {
            grupos.anteriores.push(item);
        }
    });

    return grupos;
}

class DashboardTimeline extends Component {
    marker(item) {
        const ehConexao = item.tipolog === TIPOLOG_CONEXAO;
        const icone = ehConexao ? (ICONE_POR_DISPOSITIVO[item.dispositivo] || 'pi-sign-in') : 'pi-sign-out';
        const cor = ehConexao ? 'bg-green-500' : 'bg-red-400';
        return (
            <span className={`flex align-items-center justify-content-center border-circle ${cor} text-white flex-shrink-0`} style={{ width: '2rem', height: '2rem' }}>
                <i className={`pi ${icone}`} />
            </span>
        );
    }

    content(item) {
        const ehConexao = item.tipolog === TIPOLOG_CONEXAO;
        const nome = item.usuario || UtilService.traduzir('main.dashboard.timeline.usuario.desconhecido');
        const acao = UtilService.traduzir(ehConexao ? 'main.dashboard.timeline.conectou' : 'main.dashboard.timeline.desconectou');
        const duracao = !ehConexao ? UtilService.formatarDuracaoCurta(item.duracaoSessaoMs) : null;
        const numeroConexao = ehConexao ? item.numeroConexaoPeriodo : null;
        return (
            <div className="pb-3">
                <div>
                    <strong>{nome}</strong> {acao}
                    {item.routerboard ? <> {UtilService.traduzir('main.dashboard.timeline.em')} <strong>{item.routerboard}</strong></> : null}
                    {item.os ? <Tag className="ml-2" severity="info" value={item.os} /> : null}
                    {duracao ? <Tag className="ml-2" severity="secondary" icon="pi pi-clock" value={duracao} /> : null}
                    {!ehConexao && item.bytesin > 0 ? <Tag className="ml-2" severity="secondary" icon="pi pi-cloud-upload" value={UtilService.formatarBytesVolume(item.bytesin)} pt={{ root: { title: UtilService.traduzir('main.dashboard.timeline.upload') } }} /> : null}
                    {!ehConexao && item.bytesout > 0 ? <Tag className="ml-2" severity="secondary" icon="pi pi-cloud-download" value={UtilService.formatarBytesVolume(item.bytesout)} pt={{ root: { title: UtilService.traduzir('main.dashboard.timeline.download') } }} /> : null}
                    {numeroConexao ? <Tag className="ml-2" severity="secondary" icon="pi pi-hashtag" value={`${numeroConexao}ª ${UtilService.traduzir('main.dashboard.timeline.noperiodo')}`} /> : null}
                </div>
                <div className="text-color-secondary text-sm">{moment(item.datalog).format('DD/MM/YYYY HH:mm')}</div>
            </div>
        );
    }

    renderGrupo(titulo, itens) {
        if (!itens.length) return null;
        return (
            <div key={titulo} className="mb-3">
                <Divider align="left" type="solid">
                    <b>{titulo}</b>
                </Divider>
                <Timeline
                    value={itens}
                    align="left"
                    marker={(item) => this.marker(item)}
                    content={(item) => this.content(item)}
                    pt={{ opposite: { style: { display: 'none' } } }}
                />
            </div>
        );
    }

    render() {
        const { itens } = this.props;

        if (!itens || itens.length === 0) {
            return <div className="text-color-secondary text-center p-4">{UtilService.traduzir('main.dashboard.timeline.semdados')}</div>;
        }

        const grupos = agruparPorDia(itens);

        return (
            <div>
                {this.renderGrupo(UtilService.traduzir('main.dashboard.timeline.hoje'), grupos.hoje)}
                {this.renderGrupo(UtilService.traduzir('main.dashboard.timeline.ontem'), grupos.ontem)}
                {this.renderGrupo(UtilService.traduzir('main.dashboard.timeline.anteriores'), grupos.anteriores)}
            </div>
        );
    }
}

export default DashboardTimeline;
